module.exports = __webpack_public_path__ + "img/brand5.537628bf.png";